import React, { useContext } from 'react';
import { CustomizedTypography } from '@components/Customized';
import { Enterprise } from '@carbon/icons-react';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { CompanyInfoDetailSection } from './styled';

const CompanyFoundedIn: React.FunctionComponent = () => {
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;

  if (!partnerInfo?.foundedIn) return null;

  return (
    <CompanyInfoDetailSection>
      <div className="data-row">
        <div className="row-title">
          <Enterprise size={20} />
          <CustomizedTypography>설립년도</CustomizedTypography>
        </div>

        {partnerInfo?.foundedIn ? (
          <CustomizedTypography className="row-value">
            {partnerInfo?.foundedIn}년
          </CustomizedTypography>
        ) : (
          <CustomizedTypography className="no-data">
            아직 정보가 없습니다
          </CustomizedTypography>
        )}
      </div>
    </CompanyInfoDetailSection>
  );
};

export default CompanyFoundedIn;
